(() => {
  const sheet = document.querySelector("[data-gettmi-size-guide-sheet]");
  let sizeGuideOpener = null;

  function closeSizeGuide() {
    if (!sheet || sheet.hidden) return;
    sheet.hidden = true;
    document.body.classList.remove("gettmi-size-guide-is-open");
    if (sizeGuideOpener && document.contains(sizeGuideOpener)) {
      sizeGuideOpener.focus();
    }
    sizeGuideOpener = null;
  }

  document.addEventListener("click", (event) => {
    const back = event.target.closest("[data-gettmi-pdp-back]");
    if (back) {
      event.preventDefault();
      if (window.history.length > 1) {
        window.history.back();
      } else {
        window.location.assign("/");
      }
      return;
    }

    const openSizeGuide = event.target.closest("[data-gettmi-open-size-guide]");
    if (openSizeGuide && sheet) {
      event.preventDefault();
      sizeGuideOpener = openSizeGuide;
      sheet.hidden = false;
      document.body.classList.add("gettmi-size-guide-is-open");
      sheet.querySelector("[data-gettmi-close-size-guide]")?.focus();
      return;
    }

    if (event.target.closest("[data-gettmi-close-size-guide]")) {
      event.preventDefault();
      closeSizeGuide();
    }
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") closeSizeGuide();
  });
})();
